/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

import useAuth from 'hooks/useAuth';
import axios from 'utils/axios';
import { URL_API_SERVICE } from 'config';
import consoleSistema from 'utils/consoleSistema';

const VALIDACION_LABELS = {
    es_cuarentena: 'Cuarentena',
    es_rechazado: 'Rechazado',
    es_aprobado: 'Aprobado',
    es_caducado: 'Caducado'
};

const VALIDACION_ORDER = ['es_cuarentena', 'es_rechazado', 'es_aprobado', 'es_caducado'];

const isBodegaConfigurada = (message) =>
    String(message ?? '').toLowerCase().includes('bodega configurada');

const fetchWarehouseValidation = (id_company) => {
    const token = localStorage.getItem('serviceToken');
    return axios
        .post(
            `${URL_API_SERVICE}warehouse`,
            { operacion: 'validateWarehousesPorDefectoByIdCompany', id_company },
            { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((response) => response.data);
};

const WarehouseValidationDialog = () => {
    const { isLoggedIn, company } = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [validacion, setValidacion] = useState({});
    const validatedCompanyRef = useRef(null);

    useEffect(() => {
        const idCompany = company?.id_company;

        if (!isLoggedIn || !idCompany) {
            validatedCompanyRef.current = null;
            return;
        }

        if (validatedCompanyRef.current === idCompany) {
            return;
        }

        validatedCompanyRef.current = idCompany;

        fetchWarehouseValidation(idCompany)
            .then((response) => {
                if (response?.configuracion_completa === true) {
                    setOpen(false);
                    setValidacion({});
                    return;
                }

                setValidacion(response?.validacion ?? {});
                setOpen(true);
            })
            .catch((err) => {
                consoleSistema('WarehouseValidationDialog', err);
                validatedCompanyRef.current = null;
            });
    }, [isLoggedIn, company?.id_company]);

    const handleOk = () => {
        setOpen(false);
        navigate('/user/list-warehouse-view');
    };

    return (
        <Dialog
            open={open}
            onClose={handleOk}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    border: '2px solid',
                    borderColor: 'error.main'
                }
            }}
        >
            <DialogTitle
                sx={{
                    bgcolor: 'error.light',
                    color: 'error.dark',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}
            >
                <WarningAmberIcon color="error" />
                Configuración de bodegas incompleta
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <Typography variant="body2" color="error.main" sx={{ mb: 2 }}>
                    Debe configurar una bodega por defecto para cada tipo antes de continuar.
                </Typography>
                <List dense disablePadding>
                    {VALIDACION_ORDER.map((key) => {
                        const message = validacion[key];
                        if (!message) return null;
                        const configured = isBodegaConfigurada(message);

                        return (
                            <ListItem key={key} disableGutters sx={{ py: 0.75 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    {configured ? (
                                        <CheckCircleIcon color="success" fontSize="small" />
                                    ) : (
                                        <ErrorIcon color="error" fontSize="small" />
                                    )}
                                </ListItemIcon>
                                <ListItemText
                                    primary={VALIDACION_LABELS[key]}
                                    secondary={message}
                                    primaryTypographyProps={{ fontWeight: 600 }}
                                    secondaryTypographyProps={{
                                        color: configured ? 'text.secondary' : 'error.main'
                                    }}
                                />
                            </ListItem>
                        );
                    })}
                </List>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <Button variant="contained" color="error" onClick={handleOk}>
                        OK
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default WarehouseValidationDialog;
